import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments';
import {
  PrestationHistoryParams,
  PrestationHistoryResponse,
  Prestation,
} from '../interfaces/prestation.interface';

@Injectable({
  providedIn: 'root',
})
export class PrestationService {
  private apiUrl = `${environment.apiUrl}/prestations`;

  constructor(private http: HttpClient) {}

  /**
   * Récupère l'historique des prestations avec pagination et filtres
   */
  getPrestationHistory(
    params: PrestationHistoryParams
  ): Observable<PrestationHistoryResponse> {
    let httpParams = new HttpParams();

    if (params.page)
      httpParams = httpParams.set('page', params.page.toString());
    if (params.limit)
      httpParams = httpParams.set('limit', params.limit.toString());
    if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy);
    if (params.order) httpParams = httpParams.set('order', params.order);
    if (params.includeMedicalActs !== undefined)
      httpParams = httpParams.set(
        'includeMedicalActs',
        params.includeMedicalActs.toString()
      );
    if (params.passportNumber)
      httpParams = httpParams.set('passportNumber', params.passportNumber);
    if (params.policeExternalId)
      httpParams = httpParams.set('policeExternalId', params.policeExternalId);

    return this.http.get<PrestationHistoryResponse>(`${this.apiUrl}`, {
      params: httpParams,
    });
  }

  /**
   * Récupère les prestations d'un passeport spécifique
   */
  getPassportPrestations(passportId: string): Observable<Prestation[]> {
    return this.http.get<Prestation[]>(`${this.apiUrl}/passport/${passportId}`);
  }

  /**
   * Récupère une prestation par son ID
   */
  getPrestationById(id: string): Observable<Prestation> {
    return this.http.get<Prestation>(`${this.apiUrl}/${id}`);
  }

  /**
   * Récupère les ordonnances d'une prestation
   */
  getPrestationPrescriptions(prestationId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${prestationId}/prescriptions`);
  }

  /**
   * Récupère les examens demandés d'une prestation
   */
  getPrestationRequestedExams(prestationId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${prestationId}/requested-exams`);
  }
}
